import React, { useState } from 'react';
import axios from 'axios';

const TikTokUpload = () => {
    const [videoFile, setVideoFile] = useState(null);
    const [status, setStatus] = useState('');

    const handleFileChange = (e) => {
        setVideoFile(e.target.files[0]);
    };

    const uploadToTikTok = async () => {
        const accessToken = localStorage.getItem('tiktok_access_token');
        const openId = localStorage.getItem('tiktok_open_id');

        if (!accessToken || !openId) {
            setStatus('❌ TikTok not connected. Please login first.');
            return;
        }

        setStatus('🔄 Uploading to TikTok...');

        try {
            // 1. Initialize video upload
            const initRes = await axios.post(
                'https://open-sandbox.tiktokapis.com/v2/video/upload/init/',
                {
                    source_info: { source: 'file' },
                    video_size: videoFile.size
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            const { upload_url, video_id } = initRes.data.data;

            // 2. Upload to TikTok signed URL
            await axios.put(upload_url, videoFile, {
                headers: { 'Content-Type': 'video/mp4' }
            });

            // 3. Publish video
            await axios.post(
                'https://open-sandbox.tiktokapis.com/v2/video/publish/',
                {
                    video_id: video_id,
                    open_id: openId
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            setStatus('✅ Video uploaded successfully!');
        } catch (error) {
            console.error(error);
            setStatus('❌ Upload failed. Check console for details.');
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <h3>Upload Video to TikTok</h3>
            <input type="file" accept="video/mp4" onChange={handleFileChange} />
            <br /><br />
            <button
                className="btn puprple_btn"
                onClick={uploadToTikTok}
                disabled={!videoFile}
            >
                Upload to TikTok
            </button>
            <p>{status}</p>
        </div>
    );
};

export default TikTokUpload;
